import { BlockModel, LayoutBlockTypesEnum } from './block.model';
import { LayoutDisplayElement } from './layout-display-element.model';
import { LayoutBlockType } from './layout-block-type.model';


export class LayoutBlock extends BlockModel {

    blocks: BlockModel[][];
    type: LayoutBlockType;
    displayElement: LayoutDisplayElement;
    isLayoutBlock: boolean = true;

    constructor(id?: number, type?: LayoutBlockType, displayElement?: LayoutDisplayElement, blocks?: BlockModel[][]) {
        super(id, type, displayElement);
        if (blocks) {
            this.blocks = blocks;
        } else {
            switch (type.key as LayoutBlockTypesEnum) {
                case LayoutBlockTypesEnum.distributionOne:
                case LayoutBlockTypesEnum.briefingOne:
                    this.blocks = [[]];
                    break;
                case LayoutBlockTypesEnum.distributionTwo:
                case LayoutBlockTypesEnum.briefingTwo:
                    this.blocks =[[], []];
                    break;
                case LayoutBlockTypesEnum.distributionThree:
                case LayoutBlockTypesEnum.briefingThree:
                    this.blocks = [[], [], []];
                    break;
            }
        }
        if (displayElement) {
            this.displayElement = new LayoutDisplayElement(displayElement.styles);
        }

        // Cache this value for the purposes of templates
        this.isLayoutBlock = super.isLayoutBlockType();
    }

    clone(): LayoutBlock {
        const layoutBlock = new LayoutBlock(
            this.id,
            (this.type as LayoutBlockType).clone(),
            this.displayElement.clone(),
            this.blocks.map(column => column.map(block => block.clone()))
        );
        // for some reason this.type.clone calls the parent blockType clone
        // so need to manually clone the method here
        layoutBlock.type.disableDropCondition = this.type.disableDropCondition;

        return layoutBlock;
    }
};
